"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_USER_ERROR = exports.USER_SIGNED_OUT = exports.LOADING_USER = exports.USER_FOUND = exports.USER_EXPIRING = exports.SESSION_TERMINATED = exports.SILENT_RENEW_ERROR = exports.USER_LOADED = exports.REDIRECT_SUCCESS = exports.USER_EXPIRED = void 0;
var USER_EXPIRED = 'kubra-auth/USER_EXPIRED';
exports.USER_EXPIRED = USER_EXPIRED;
var REDIRECT_SUCCESS = 'kubra-auth/REDIRECT_SUCCESS';
exports.REDIRECT_SUCCESS = REDIRECT_SUCCESS;
var USER_LOADED = 'kubra-auth/USER_LOADED';
exports.USER_LOADED = USER_LOADED;
var SILENT_RENEW_ERROR = 'kubra-auth/SILENT_RENEW_ERROR';
exports.SILENT_RENEW_ERROR = SILENT_RENEW_ERROR;
var SESSION_TERMINATED = 'kubra-auth/SESSION_TERMINATED';
exports.SESSION_TERMINATED = SESSION_TERMINATED;
var USER_EXPIRING = 'kubra-auth/USER_EXPIRING';
exports.USER_EXPIRING = USER_EXPIRING;
var USER_FOUND = 'kubra-auth/USER_FOUND';
exports.USER_FOUND = USER_FOUND;
var LOADING_USER = 'kubra-auth/LOADING_USER';
exports.LOADING_USER = LOADING_USER;
var USER_SIGNED_OUT = 'kubra-auth/USER_SIGNED_OUT';
exports.USER_SIGNED_OUT = USER_SIGNED_OUT;
var LOAD_USER_ERROR = 'kubra-auth/LOAD_USER_ERROR';
exports.LOAD_USER_ERROR = LOAD_USER_ERROR;